import React from 'react';
import { UserIcon, EnvelopeIcon, BuildingOfficeIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const ROL_LABELS = {
  owner: 'Administrador',
  operator: 'Operador',
};

const ConfiguracionPerfil = ({ userData }) => {
  const fields = [
    { label: 'Nombre', value: userData?.nombre, icon: UserIcon },
    { label: 'Correo electrónico', value: userData?.correo, icon: EnvelopeIcon },
    { label: 'Organización', value: userData?.org, icon: BuildingOfficeIcon },
    { label: 'Rol', value: ROL_LABELS[userData?.rol] || userData?.rol, icon: ShieldCheckIcon },
  ];

  return (
    <div className="max-w-2xl">
      <p className="text-sm text-zinc-500 mb-6">
        Información de tu cuenta. Para realizar cambios, contacta a soporte.
      </p>

      <div className="divide-y divide-zinc-100 rounded-xl border border-zinc-200 bg-white">
        {fields.map((field) => (
          <div key={field.label} className="flex items-center gap-4 px-5 py-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-azul-surelia/10 text-azul-surelia">
              <field.icon className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-medium text-zinc-400">{field.label}</p>
              <p className="text-sm font-medium text-zinc-900 truncate">{field.value || '—'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfiguracionPerfil;
